import { render, staticRenderFns } from "./AssemblyItems.vue?vue&type=template&id=b73b9b36&"
import script from "./AssemblyItems.vue?vue&type=script&lang=js&"
export * from "./AssemblyItems.vue?vue&type=script&lang=js&"
import style0 from "./AssemblyItems.vue?vue&type=style&index=0&id=b73b9b36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports